import { motion } from "framer-motion";
import Whale3D from "@/components/site/Whale3D";

const stagger = {
  hidden: {},
  show: { transition: { staggerChildren: 0.12, delayChildren: 0.15 } },
};
const item = {
  hidden: { y: 24, opacity: 0 },
  show: { y: 0, opacity: 1, transition: { duration: 0.8, ease: [0.2, 0.7, 0.2, 1] } },
};

export default function Hero() {
  const scrollTo = (id) => (e) => {
    e.preventDefault();
    document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <section id="top" data-testid="hero-section" className="relative min-h-[100vh] w-full overflow-hidden">
      <Whale3D />

      {/* Soft overlay gradient for text legibility */}
      <div className="absolute inset-0 pointer-events-none bg-gradient-to-b from-transparent via-[#05050A]/20 to-[#05050A]" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 pt-40 md:pt-44 lg:pt-52 pb-24">
        <motion.div variants={stagger} initial="hidden" animate="show" className="max-w-3xl">
          <motion.div variants={item} className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 backdrop-blur px-4 py-1.5 text-xs md:text-sm text-slate-300">
            <span className="h-2 w-2 rounded-full bg-gradient-to-r from-purple-400 to-blue-400 shadow-[0_0_10px_rgba(147,51,234,0.7)]" />
            Agenzia di digital marketing · Est. 2025
          </motion.div>

          <motion.h1
            variants={item}
            data-testid="hero-headline"
            className="font-display mt-6 text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold tracking-tighter leading-[0.95] text-white"
          >
            Facciamo emergere <br />
            il tuo <span className="text-gradient">brand</span> nel <br />
            mare dei <span className="italic font-medium">social</span>.
          </motion.h1>

          <motion.p variants={item} className="mt-8 max-w-xl text-base md:text-lg text-slate-300/90 leading-relaxed">
            Social Whale aiuta aziende e imprese locali a crescere online con strategie
            creative, contenuti d'impatto e advertising misurabile. Dallo storytelling al negozio,
            trasformiamo ogni scroll in un cliente reale.
          </motion.p>

          <motion.div variants={item} className="mt-10 flex flex-wrap items-center gap-4">
            <a
              href="#servizi"
              onClick={scrollTo("#servizi")}
              data-testid="hero-cta-servizi"
              className="btn-primary"
            >
              Scopri i servizi
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12h14M13 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </a>
            <a
              href="#contattaci"
              onClick={scrollTo("#contattaci")}
              data-testid="hero-cta-contattaci"
              className="btn-ghost"
            >
              Contattaci
            </a>
          </motion.div>

          <motion.div variants={item} className="mt-14 grid grid-cols-3 max-w-md gap-6">
            {[
              { k: "+120%", v: "Follower medi" },
              { k: "3.4x", v: "Engagement" },
              { k: "24/7", v: "Community" },
            ].map((x) => (
              <div key={x.v} className="border-l border-white/10 pl-4">
                <div className="font-display text-2xl md:text-3xl text-white">{x.k}</div>
                <div className="text-xs uppercase tracking-widest text-slate-400 mt-1">{x.v}</div>
              </div>
            ))}
          </motion.div>
        </motion.div>
      </div>

      {/* Scroll cue */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-slate-400 text-xs tracking-widest uppercase">
        <span>Scroll</span>
        <span className="h-8 w-[1px] bg-gradient-to-b from-white/40 to-transparent" />
      </div>
    </section>
  );
}
